





























import { Component } from 'vue-property-decorator';
import RecurringPaymentsProductManagementMixin
  from '@/components/product/recurringPayments/recurringPaymentsProductManagement/RecurringPaymentsProductManagementMixin';
import SearchForm from '@/components/product/recurringPayments/recurringPaymentsProductManagement/SearchForm.vue';
import SearchResult from '@/components/product/recurringPayments/recurringPaymentsProductManagement/SearchResult.vue';
import { namespace } from 'vuex-class';
import { Mall } from 'supporter';
import _ from 'underscore';

const mallStore = namespace('mall');

@Component({
  components: {
    SearchForm,
    SearchResult,
  }
})
export default class RecurringPaymentsProductManagement extends RecurringPaymentsProductManagementMixin {

  @mallStore.Getter('mallsSortedByCreationDate')
  private mallsSortedByCreationDate!: Mall[];
  private noticeList: string[] = _.range(1, 2)
      .map(number => this.getI18nOfThis(`DESCRIPTION_${number}`));
  private isThereQuery = false;

  private created() {
    // 새로고침 핸들 -> 쿼리 삭제 후 검색됨
    // TODO: 다른 페이지에서 진입해야 할 경우 생긴다면 SearchForm과 함께 수정 필요

    if (Object.keys(this.$route.query).length) {
      this.isThereQuery = true; // TODO: 새로고침시 상품조회 api 요청이 두 번 일어나는 경우를 막기위한 조치이지만, 우아하지 않다.
      this.$router.replace(this.$route.path).then(() => {
        this.isThereQuery = false;
      });
    }
  }

  private mounted() {
    let descriptionAboutTerms = this.getI18nOfThis('DESCRIPTION_ABOUT_TERMS');
    if (this.mallsSortedByCreationDate.length) {
      descriptionAboutTerms += ' ' + `<a href="/terms/tab/e-commerce?mallNo=${this.mallsSortedByCreationDate[this.mallsSortedByCreationDate.length - 1].mallNo}" target="_blank" rel="noopener noreferrer">${this.getI18nOfThis('GO_TO_TERMS_OF_USE')}</a>`
    }
    this.noticeList = [ descriptionAboutTerms, ...this.noticeList ];
  }
}
